module.exports = __webpack_public_path__ + "img/swapping-box.ff784bd2.gif";